import {useGeneralInput} from '../generalInput/regularInput'

export const useUserNameInput = ({className = '', initialvalue = ''}) =>
  useGeneralInput({
    initialvalue,
    className,
    tagType: 'input',
    label: 'نام کاربری',
    isRequired: true,
    placeholder: 'نام کاربری را وارد کنید',
  })

export const usePasswordInput = ({className = '', initialvalue = ''}) =>
  useGeneralInput({
    initialvalue,
    className,
    type: 'password',
    tagType: 'input',
    label: 'رمز عبور',
    isRequired: true,
    placeholder: 'رمز عبور خود را وارد کنید',
  })

export const usePhoneNumberInput = ({className = '', initialvalue = ''}) =>
  useGeneralInput({
    initialvalue,
    className,
    tagType: 'input',
    label: 'شماره تماس',
    isRequired: true,
    isTypeValueNumber: true,
    placeholder: 'شماره تماس را وارد کنید',
  })
